<template>
  <v-tooltip :text="listening ? 'Stop recording' : 'Voice input (English)'" location="top">
    <template #activator="{ props: tp }">
      <v-btn
        v-bind="tp"
        :icon="true"
        size="x-small"
        :color="listening ? 'error' : 'medium-emphasis'"
        :variant="listening ? 'flat' : 'text'"
        :class="{ 'voice-pulse': listening }"
        @click="toggle"
      >
        <v-icon size="18">{{ listening ? 'mdi-microphone-off' : 'mdi-microphone' }}</v-icon>
      </v-btn>
    </template>
  </v-tooltip>
</template>

<script setup>
import { ref, onUnmounted } from 'vue'

const emit = defineEmits(['result'])

const listening = ref(false)
let recognition = null

function toggle() {
  if (listening.value) {
    stop()
  } else {
    start()
  }
}

function start() {
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
  if (!SpeechRecognition) {
    console.warn('[VoiceInput] Speech recognition not supported')
    return
  }

  recognition = new SpeechRecognition()
  recognition.lang = 'en-US'
  recognition.continuous = true
  recognition.interimResults = false

  recognition.onresult = (event) => {
    let transcript = ''
    for (let i = event.resultIndex; i < event.results.length; i++) {
      if (event.results[i].isFinal) {
        transcript += event.results[i][0].transcript
      }
    }
    if (transcript.trim()) {
      emit('result', transcript.trim())
    }
  }

  recognition.onerror = (event) => {
    console.warn('[VoiceInput] Error:', event.error)
    listening.value = false
  }

  recognition.onend = () => {
    listening.value = false
  }

  recognition.start()
  listening.value = true
}

function stop() {
  if (recognition) {
    recognition.stop()
    recognition = null
  }
  listening.value = false
}

onUnmounted(() => {
  stop()
})
</script>

<style scoped>
.voice-pulse {
  animation: pulse-ring 1.2s infinite;
}

@keyframes pulse-ring {
  0% { box-shadow: 0 0 0 0 rgba(var(--v-theme-error), 0.4); }
  70% { box-shadow: 0 0 0 6px rgba(var(--v-theme-error), 0); }
  100% { box-shadow: 0 0 0 0 rgba(var(--v-theme-error), 0); }
}
</style>
